import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import activityReducer from './activity/activity.reducer';
import authReducer from './auth/auth.reducer';
import catalogReducer from './catalog/catalog.reducer';
import categoryReducer from './category/category.reducer';
import clientReducer from './client/client.reducer';
import courseReducer from './course/course.reducer';
import eventReducer from './event/event.reducer';
import faqReducer from './faq/faq.reducer';
import homeReducer from './home/home.reducer';
import paymentReducer from './payment/payment.reducer';
import profileReducer from './profile/profile.reducer';
import quizReducer from './quiz/quiz.reducer';
import packageReducer from './subscription/package.reducer';
import testimonialReducer from './testimonial/testimonial.reducer';
import transactionReducer from './transaction/transaction.reducer';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'faq'],
};

const rootReducer = combineReducers({
  auth: authReducer,
  activity: activityReducer,
  home: homeReducer,
  client: clientReducer,
  category: categoryReducer,
  course: courseReducer,
  event: eventReducer,
  transaction: transactionReducer,
  quiz: quizReducer,
  payment: paymentReducer,
  profile: profileReducer,
  catalog: catalogReducer,
  faq: faqReducer,
  testimonial: testimonialReducer,
  package: packageReducer,
});

export default persistReducer(persistConfig, rootReducer);
